import { ImageFormat } from '../services/imageService';

export interface FormatInfo {
  extension: string;
  mimeType: string;
  transparency: boolean;
  animation: boolean;
}

export const formatInfo: Record<ImageFormat, FormatInfo> = {
  jpeg: {
    extension: '.jpg, .jpeg',
    mimeType: 'image/jpeg',
    transparency: false,
    animation: false,
  },
  png: {
    extension: '.png',
    mimeType: 'image/png',
    transparency: true,
    animation: false,
  },
  webp: {
    extension: '.webp',
    mimeType: 'image/webp',
    transparency: true,
    animation: true,
  },
  avif: {
    extension: '.avif',
    mimeType: 'image/avif',
    transparency: true,
    animation: true,
  },
  gif: {
    extension: '.gif',
    mimeType: 'image/gif',
    transparency: true,
    animation: true,
  },
  bmp: {
    extension: '.bmp',
    mimeType: 'image/bmp',
    transparency: false,
    animation: false,
  },
  ico: {
    extension: '.ico',
    mimeType: 'image/x-icon',
    transparency: true,
    animation: false,
  },
  svg: {
    extension: '.svg',
    mimeType: 'image/svg+xml',
    transparency: true,
    animation: true,
  },
};
